import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { OrganisationEntryRemoteDto } from 'src/generated/swagger';
import { BaseDirectoryEditComponent } from '../base-directory-edit/base-directory-edit.component';

@Component({
   selector: 'samweb-orgfield-column-edit',
   templateUrl: './orgfield-column-edit.component.html',
   styleUrls: ['./orgfield-column-edit.component.scss'],
})
export class OrgFieldColumnEditComponent extends BaseDirectoryEditComponent implements OnInit {
   constructor(public store: Store) {
      super();
   }

   private noEntry = <OrganisationEntryRemoteDto>{
      id: 0,
      orgum: null,
      orgnam: '-',
   };

   ngOnInit(): void {
      this.orgdata = [this.noEntry, ...this.orgdata];
   }

   selectedEntry(): OrganisationEntryRemoteDto {
      return this.orgdata.find((entry) => entry.id === this.value);
   }

   updatedEntry(): OrganisationEntryRemoteDto {
      return this.orgdata.find((entry) => entry.id === this.valueUpdated);
   }

   selectionChange(entry: OrganisationEntryRemoteDto) {
      this.valueChanged.emit(entry.id);
   }

   takeOtherClick() {
      this.takeOther.emit(this.valueUpdated);
   }
}
